<template>
  <div class="grid-container full container">
    <div class="grid-x page-contents-8" >

      <div class=" small-12 medium-7 cell left-column">
        <h2>Attraction & Development</h2>
        <p class="standardcase">
          We are experts in early talent. We connect exceptional sixth form students, undergraduates and recent
          graduates with top universities and employers. We help them show their full potential through one-to-one
          development, expert advice and exclusive events.
        </p>
      </div>

      <div class="small-12 medium-5 cell right-column small-text-center">
        <div class="graphicContainer">
          <p class="graphiclabel">For every five applications, two interviews, one hire</p>
          <img
            class="appsIntsHiresGraphic"
            src="@/assets/img/icons/apps-ints-hire.png"
            alt="Attraction and Development, Contextual Recruitment Info-graphic." />
        </div>
      </div>

    </div>
  </div>
</template>
<script>

import RareStandardButton from '@/components/atoms/RareWebButton';

export default {
  name: 'RareHomeProductsAttractionDevelopment',
  components: {
    'rare-standard-button': RareStandardButton,
  },
  methods: {
    openContactForm() {
      this.$root.$emit('updateContactForm', true);
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .container {
    border-bottom: 1px solid $border;
  }

  h2 {
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  }

  @media only screen and (max-width: 640px) {
    .right-column {
      padding-right: 0;
    }

    .graphicContainer {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    h2 {
      font-size: 28px;
      line-height: 1.43;
      margin: 38px 0 8px 0;
      text-align: center;
    }

    .appsIntsHiresGraphic {
      margin: 0 auto 40px auto;
      max-height: 271px;
    }

    .contactButton {
      margin: 18px auto 30px auto;
    }

    .standardcase {
      text-align: center;
    }

    .graphiclabel {
      font-size: 14px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.71;
      letter-spacing: 2px;
      text-align: center;
      margin-top: 5px;
      max-width: 271px;
      margin-left: auto;
      margin-right: auto;
      text-transform: uppercase;
    }

  }

  @media only screen and (min-width: 641px) {
    .right-column {
      padding-left: 20px;
      max-width: 700px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .left-column {
      padding-bottom: 34px;
    }

    .graphicContainer {
      margin: 30px 0;
    }

    p.tag {
      font-size: 30px;
    }

    h2 {
      font-size: 56px;
      line-height: 1.29;
      margin: 115px 0 20px 0;
      text-align: left;
    }

    .appsIntsHiresGraphic {
      margin-top: 20px;
      max-height: 376px;
    }

    .contactButton {
      margin: 24px 0 96px 0;
    }

    .graphiclabel {
      font-size: 18px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.78;
      letter-spacing: 2px;
      text-align: center;
      margin: 0 auto 0 auto;
      max-width: 376px;
      text-transform: uppercase;
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsAttractionAndDevelopment/components/RareHomeProductsAttractionDevelopment.vue